var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { LOCATION_ATTRIBUTE_DISPLAY_NAMES, LOCATION_ATTRIBUTE_NAMES, LOCATION_CATEGORY_DISPLAY_NAMES, LOCATION_PLUGIN_UIDS, } from '../constants/location';
import { SUPPORTED_PREDICATES as PRED } from '../constants/types';
import { BOOL_STATEMENTS, DATE_TIME_STATEMENTS, INT_FLOAT_STATEMENTS, STRING_STATEMENTS } from '../constants/dropdowns';
export var getConstraints = function (uiBlock) {
    var valueConstraint = uiBlock.valueConstraint, predicateConstraint = uiBlock.predicateConstraint, contextConstraint = uiBlock.contextConstraint;
    if (predicateConstraint === null || predicateConstraint === void 0 ? void 0 : predicateConstraint.isReadOnly)
        return {
            isDeleteLocked: true,
            isValueLocked: true,
            operationConstraint: 'locked',
        };
    var isDeleteLocked = !!valueConstraint || !!contextConstraint;
    var isValueLocked = !!(valueConstraint === null || valueConstraint === void 0 ? void 0 : valueConstraint.isReadOnly);
    var operationConstraint = !!(contextConstraint === null || contextConstraint === void 0 ? void 0 : contextConstraint.isReadOnly) && uiBlock.type === 'historical'
        ? 'historical'
        : !!(contextConstraint === null || contextConstraint === void 0 ? void 0 : contextConstraint.isReadOnly)
            ? 'regular'
            : '';
    var allowedValues = valueConstraint === null || valueConstraint === void 0 ? void 0 : valueConstraint.allowedValues;
    return { isDeleteLocked: isDeleteLocked, isValueLocked: isValueLocked, operationConstraint: operationConstraint, allowedValues: allowedValues };
};
// Validation helpers
export var validateInteger = function (inputValue) {
    var intRegex = /^(\+|-)?\d*$/;
    return intRegex.test(inputValue);
};
export var validateFloat = function (inputValue) {
    var floatRegex = /^(\+|-)?\d*\.?\d*$/;
    return floatRegex.test(inputValue);
};
// simple validate function checks for empty, unmatched brackets, out of bound
// predicates, and spelling/logic mistakes.  It also squishes predicates with
// each other together through removing whitespace, so there are some edge
// cases that might be let through, but back end will have to validate anyway,
// so I don't see it as a huge issue
export var validateLogicString = function (ls, predicateCount) {
    var tString = ls.replace(/\s/g, '');
    if (tString === '')
        return false;
    // checks validity of the node (spelling or bounds)
    var checkNode = function (str, nodeType) {
        if (nodeType === 'op') {
            if (str !== 'and' && str !== 'or') {
                return false;
            }
        }
        else {
            if (parseInt(str, 10) > predicateCount) {
                return false;
            }
        }
        return true;
    };
    // lexes the next symbols
    var getNode = function (idx, str) {
        if (str[idx] === '(')
            return ['lb', idx + 1];
        if (str[idx] === ')')
            return ['rb', idx + 1];
        if (/[ao]/.test(str[idx])) {
            var opIdx = idx;
            while (str[opIdx] !== undefined && /[andor]/.test(str[opIdx])) {
                opIdx++;
            }
            if (checkNode(str.slice(idx, opIdx), 'op')) {
                return ['op', opIdx];
            }
            else {
                return ['failed', -1];
            }
        }
        if (/[1-9]/.test(str[idx])) {
            var tmIdx = idx;
            while (str[tmIdx] !== undefined && /[0-9]/.test(str[tmIdx])) {
                tmIdx++;
            }
            if (checkNode(str.slice(idx, tmIdx), 'term')) {
                return ['tm', tmIdx];
            }
            else {
                return ['failed', -1];
            }
        }
        return ['failed', -1];
    };
    var state = 'lb';
    var depth = 0;
    var i = 0;
    // state machine for managing the grammar
    while (i < tString.length) {
        var _a = __read(getNode(i, tString), 2), nextState = _a[0], nextIndex = _a[1];
        if (nextState === 'failed') {
            return false;
        }
        i = nextIndex;
        if (state === 'lb') {
            if (nextState === 'lb') {
                depth++;
            }
            else if (nextState === 'tm') {
                state = 't1';
            }
            else {
                return false;
            }
        }
        else if (state === 't1') {
            if (nextState === 'op') {
                state = 'op';
            }
            else {
                return false;
            }
        }
        else if (state === 'op') {
            if (nextState === 'lb') {
                state = 'lb';
                depth++;
            }
            else if (nextState === 'tm') {
                state = 'tn';
            }
            else {
                return false;
            }
        }
        else if (state === 'tn') {
            if (nextState === 'rb') {
                state = 'rb';
                depth--;
            }
            else if (nextState === 'op') {
                state = 'op';
            }
            else {
                return false;
            }
        }
        else if (state === 'rb') {
            if (nextState === 'rb') {
                depth--;
            }
            else if (nextState === 'op') {
                state = 'op';
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }
    if (depth !== 0)
        return false;
    if (state !== 'tn' && state !== 't1' && state !== 'rb')
        return false;
    return true;
};
// Used to determine freeform or dropdown field
var getValueTypeOptions = function (uiBlock, contextPlugins) {
    var _a;
    var filteredPlugins = Array.isArray(contextPlugins) && contextPlugins.filter(function (plugin) { return plugin.category === uiBlock.category; })[0];
    if (!filteredPlugins)
        return [];
    var pluginValues = filteredPlugins.values;
    return ((_a = pluginValues[uiBlock.attributeName]) === null || _a === void 0 ? void 0 : _a.valueTypeOptions) || [];
};
export var getValueOptionsMap = function (uiBlock, contextPlugins) {
    var e_1, _a;
    var valueOptionsMap = [];
    var valueTypeOptions = getValueTypeOptions(uiBlock, contextPlugins);
    if (!valueTypeOptions.length) {
        return valueOptionsMap;
    }
    var isDropDownField = false;
    try {
        for (var valueTypeOptions_1 = __values(valueTypeOptions), valueTypeOptions_1_1 = valueTypeOptions_1.next(); !valueTypeOptions_1_1.done; valueTypeOptions_1_1 = valueTypeOptions_1.next()) {
            var option = valueTypeOptions_1_1.value;
            if (!!option.value) {
                isDropDownField = true;
                break;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (valueTypeOptions_1_1 && !valueTypeOptions_1_1.done && (_a = valueTypeOptions_1.return)) _a.call(valueTypeOptions_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var allowedValues = getConstraints(uiBlock).allowedValues;
    if (allowedValues && allowedValues.length !== 0) {
        allowedValues.forEach(function (option) {
            if (!isDropDownField || valueTypeOptions.find(function (opt) { return (opt === null || opt === void 0 ? void 0 : opt.value) === option.value; }))
                valueOptionsMap.push({ key: option.value, name: option.displayName || option.value });
        });
    }
    else if (isDropDownField) {
        valueTypeOptions.forEach(function (option) {
            return valueOptionsMap.push({ key: option.value, name: option.displayName || option.value });
        });
    }
    return valueOptionsMap;
};
export var throttledCall = function (bundle) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    bundle.q.push(args);
    if (bundle.timer !== 0) {
        return;
    }
    else {
        bundle.timer = window.setTimeout(function () {
            bundle.fn.apply(bundle, __spreadArray([], __read(bundle.q.pop()), false));
            bundle.timer = 0;
            bundle.q = [];
        }, 100);
    }
};
// PARAMETERS
// TODO: combine above and below using a make function
export var getAttributeParameters = function (uiBlock, contextPlugins) {
    var _a, _b;
    var filteredPlugins = Array.isArray(contextPlugins) && contextPlugins.filter(function (plugin) { return plugin.category === uiBlock.category; })[0];
    if (!filteredPlugins)
        return [];
    var pluginValues = filteredPlugins.values;
    return (_b = (_a = pluginValues[uiBlock.attributeName]) === null || _a === void 0 ? void 0 : _a.parameters) !== null && _b !== void 0 ? _b : [];
};
export var getParameterValues = function (uiBlock) {
    var variables = uiBlock.ctxVariable.split('.');
    var queryIndex = variables.indexOf('query');
    if (queryIndex === -1)
        return [];
    return variables.splice(queryIndex + 2, variables.length);
};
var checkAttributePlaceholder = function (uiBlock, contextPlugin, contextAttribute) {
    var _a, _b, _c;
    if (((_a = uiBlock === null || uiBlock === void 0 ? void 0 : uiBlock.hasPlaceHolder) === null || _a === void 0 ? void 0 : _a.contextOrHistorical) && (uiBlock === null || uiBlock === void 0 ? void 0 : uiBlock.attributeName) === '{{P}}') {
        return (((_b = uiBlock === null || uiBlock === void 0 ? void 0 : uiBlock.ctxVariable) === null || _b === void 0 ? void 0 : _b.replace(new RegExp('.' + (uiBlock === null || uiBlock === void 0 ? void 0 : uiBlock.attributeName) + '([^' + '.' + (uiBlock === null || uiBlock === void 0 ? void 0 : uiBlock.attributeName) + ']*)$'), '' + '$1')) === contextPlugin.uid &&
            ((uiBlock === null || uiBlock === void 0 ? void 0 : uiBlock.contextParameterType)
                ? (uiBlock === null || uiBlock === void 0 ? void 0 : uiBlock.contextParameterType) === ((_c = contextPlugin === null || contextPlugin === void 0 ? void 0 : contextPlugin.values[contextAttribute]) === null || _c === void 0 ? void 0 : _c.valueType)
                : true));
    }
    else {
        return false;
    }
};
var getIsOperatorType = function (operator, type) {
    switch (type) {
        case 'bool':
            return !!BOOL_STATEMENTS.find(function (option) { return option.value === operator; });
        case 'date':
            return !!DATE_TIME_STATEMENTS.find(function (option) { return option.value === operator; });
        case 'float':
            return !!INT_FLOAT_STATEMENTS.find(function (option) { return option.value === operator; });
        case 'int':
            return !!INT_FLOAT_STATEMENTS.find(function (option) { return option.value === operator; });
        case 'string':
            return !!STRING_STATEMENTS.find(function (option) { return option.value === operator; });
    }
};
var checkTypePlaceholder = function (uiBlock, contextPlugin, contextAttribute) {
    var _a, _b, _c;
    if ((uiBlock === null || uiBlock === void 0 ? void 0 : uiBlock.type) === '{{P}}' && ((_a = uiBlock === null || uiBlock === void 0 ? void 0 : uiBlock.hasPlaceHolder) === null || _a === void 0 ? void 0 : _a.contextOrHistorical)) {
        if (uiBlock.contextParameterType) {
            return (uiBlock === null || uiBlock === void 0 ? void 0 : uiBlock.contextParameterType) === ((_b = contextPlugin === null || contextPlugin === void 0 ? void 0 : contextPlugin.values[contextAttribute]) === null || _b === void 0 ? void 0 : _b.valueType);
        }
        else if (uiBlock.operator && uiBlock.operator !== '{{P}}') {
            return getIsOperatorType(uiBlock.operator, (_c = contextPlugin === null || contextPlugin === void 0 ? void 0 : contextPlugin.values[contextAttribute]) === null || _c === void 0 ? void 0 : _c.valueType);
        }
        else if (uiBlock.operator === '{{P}}') {
            return true;
        }
        else {
            return false;
        }
    }
};
var checkPluginPlaceholder = function (uiBlock, contextPlugin, contextAttribute) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var attribute;
    if (((_a = uiBlock === null || uiBlock === void 0 ? void 0 : uiBlock.parameterValues) === null || _a === void 0 ? void 0 : _a.length) && uiBlock.type !== 'historical') {
        attribute = "query.".concat(uiBlock.attributeName);
        uiBlock.parameterValues.forEach(function (value) {
            attribute += ".".concat(value.toString());
        });
    }
    else {
        attribute = uiBlock.attributeName;
    }
    var ctxPlugin;
    if ((_b = uiBlock.ctxVariable) === null || _b === void 0 ? void 0 : _b.includes('{{P}}')) {
        if ((_c = uiBlock === null || uiBlock === void 0 ? void 0 : uiBlock.parameterValues) === null || _c === void 0 ? void 0 : _c.length) {
            ctxPlugin = uiBlock.ctxVariable.split('.query.' + uiBlock.attributeName)[0];
        }
        else {
            ctxPlugin = uiBlock.ctxVariable.replace(new RegExp('.' + attribute + '([^' + '.' + attribute + ']*)$'), '' + '$1');
        }
    }
    else {
        ctxPlugin = "ctx.".concat((_e = (_d = uiBlock.ctxVariable) === null || _d === void 0 ? void 0 : _d.split('.')) === null || _e === void 0 ? void 0 : _e[1], ".").concat((_g = (_f = uiBlock.ctxVariable) === null || _f === void 0 ? void 0 : _f.split('.')) === null || _g === void 0 ? void 0 : _g[2]);
    }
    if (((_h = uiBlock === null || uiBlock === void 0 ? void 0 : uiBlock.hasPlaceHolder) === null || _h === void 0 ? void 0 : _h.contextOrHistorical) && (ctxPlugin === null || ctxPlugin === void 0 ? void 0 : ctxPlugin.includes('{{P}}'))) {
        if (ctxPlugin === '{{P}}') {
            var isAttribute = (uiBlock === null || uiBlock === void 0 ? void 0 : uiBlock.attributeName) === '{{P}}' || (uiBlock === null || uiBlock === void 0 ? void 0 : uiBlock.attributeName) === contextAttribute;
            return (isAttribute &&
                ((uiBlock === null || uiBlock === void 0 ? void 0 : uiBlock.contextParameterType)
                    ? (uiBlock === null || uiBlock === void 0 ? void 0 : uiBlock.contextParameterType) === ((_j = contextPlugin === null || contextPlugin === void 0 ? void 0 : contextPlugin.values[contextAttribute]) === null || _j === void 0 ? void 0 : _j.valueType)
                    : true));
        }
        else {
            var isPlugin = true;
            var leftCtxPlugin = ctxPlugin === null || ctxPlugin === void 0 ? void 0 : ctxPlugin.split('.');
            var rightCtxPlugin = (_k = contextPlugin === null || contextPlugin === void 0 ? void 0 : contextPlugin.id) === null || _k === void 0 ? void 0 : _k.split('.');
            for (var count = 0; count < rightCtxPlugin.length; count++) {
                if (leftCtxPlugin[count] !== '{{P}}' && leftCtxPlugin[count] !== rightCtxPlugin[count]) {
                    isPlugin = false;
                }
            }
            var isAttribute = (uiBlock === null || uiBlock === void 0 ? void 0 : uiBlock.attributeName) === '{{P}}' || (uiBlock === null || uiBlock === void 0 ? void 0 : uiBlock.attributeName) === contextAttribute;
            return (isPlugin &&
                isAttribute &&
                ((uiBlock === null || uiBlock === void 0 ? void 0 : uiBlock.contextParameterType)
                    ? (uiBlock === null || uiBlock === void 0 ? void 0 : uiBlock.contextParameterType) === ((_l = contextPlugin === null || contextPlugin === void 0 ? void 0 : contextPlugin.values[contextAttribute]) === null || _l === void 0 ? void 0 : _l.valueType)
                    : true));
        }
    }
    else {
        return false;
    }
};
export var retrieveOperatorValue = function (contextParameterType) {
    switch (contextParameterType) {
        case PRED.BOOL:
            return BOOL_STATEMENTS[0].value;
        case PRED.DATE:
            return DATE_TIME_STATEMENTS[0].value;
        case PRED.FLOAT:
            return INT_FLOAT_STATEMENTS[0].value;
        case PRED.INT:
            return INT_FLOAT_STATEMENTS[0].value;
        case PRED.STR:
            return STRING_STATEMENTS[0].value;
    }
};
export var retrievePlugins = function (contextPlugins, uiBlock) {
    var e_2, _a;
    var _b;
    var mappedItems = [];
    for (var contextPluginIdx = 0; contextPluginIdx < contextPlugins.length; contextPluginIdx++) {
        var contextPlugin = contextPlugins[contextPluginIdx];
        var isLocationPlugin = contextPlugin.uid === LOCATION_PLUGIN_UIDS.APPROXIMATE || contextPlugin.uid === LOCATION_PLUGIN_UIDS.PRECISE;
        var contextAttributes = Object.keys(contextPlugin.values);
        try {
            for (var contextAttributes_1 = (e_2 = void 0, __values(contextAttributes)), contextAttributes_1_1 = contextAttributes_1.next(); !contextAttributes_1_1.done; contextAttributes_1_1 = contextAttributes_1.next()) {
                var contextAttribute = contextAttributes_1_1.value;
                var isNamePlaceholder = (_b = uiBlock === null || uiBlock === void 0 ? void 0 : uiBlock.hasPlaceHolder) === null || _b === void 0 ? void 0 : _b.name;
                var isAttributePlaceholder = checkAttributePlaceholder(uiBlock, contextPlugin, contextAttribute);
                var isPluginPlaceholder = checkPluginPlaceholder(uiBlock, contextPlugin, contextAttribute);
                var isTypeContextOrHistoricalPlaceholder = checkTypePlaceholder(uiBlock, contextPlugin, contextAttribute);
                if (isNamePlaceholder || isAttributePlaceholder || isPluginPlaceholder || isTypeContextOrHistoricalPlaceholder) {
                    if (!isLocationPlugin) {
                        mappedItems.push({
                            key: contextPlugin.values[contextAttribute].uid,
                            name: "".concat(contextPlugin.category, " / ").concat(contextAttribute),
                            value: "".concat(contextAttribute),
                        });
                    }
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (contextAttributes_1_1 && !contextAttributes_1_1.done && (_a = contextAttributes_1.return)) _a.call(contextAttributes_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
    }
    return mappedItems;
};
export var retrieveSelectedPlugin = function (key, contextPlugins) {
    var e_3, _a;
    for (var contextPluginIdx = 0; contextPluginIdx < contextPlugins.length; contextPluginIdx++) {
        var contextPlugin = contextPlugins[contextPluginIdx];
        var isLocationPlugin = contextPlugin.uid === LOCATION_PLUGIN_UIDS.APPROXIMATE || contextPlugin.uid === LOCATION_PLUGIN_UIDS.PRECISE;
        var contextAttributes = Object.keys(contextPlugin.values);
        try {
            for (var contextAttributes_2 = (e_3 = void 0, __values(contextAttributes)), contextAttributes_2_1 = contextAttributes_2.next(); !contextAttributes_2_1.done; contextAttributes_2_1 = contextAttributes_2.next()) {
                var contextAttribute = contextAttributes_2_1.value;
                if (isLocationPlugin) {
                    var locationCategoryName = void 0;
                    if (contextPlugin.uid === LOCATION_PLUGIN_UIDS.APPROXIMATE) {
                        locationCategoryName = LOCATION_CATEGORY_DISPLAY_NAMES.APPROXIMATE;
                    }
                    if (contextPlugin.uid === LOCATION_PLUGIN_UIDS.PRECISE) {
                        locationCategoryName = LOCATION_CATEGORY_DISPLAY_NAMES.PRECISE;
                    }
                    var locationAttributeName = void 0;
                    if (contextAttribute === LOCATION_ATTRIBUTE_NAMES.APPROXIMATE ||
                        contextAttribute === LOCATION_ATTRIBUTE_NAMES.PRECISE) {
                        locationAttributeName = LOCATION_ATTRIBUTE_DISPLAY_NAMES.ADDRESS;
                    }
                    if (contextAttribute === LOCATION_ATTRIBUTE_NAMES.LABELS) {
                        locationAttributeName = LOCATION_ATTRIBUTE_DISPLAY_NAMES.LABEL;
                    }
                    if (locationCategoryName && locationAttributeName && key === contextPlugin.values[contextAttribute].uid) {
                        return contextPlugin;
                    }
                }
                else {
                    if (key === contextPlugin.values[contextAttribute].uid) {
                        return contextPlugin;
                    }
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (contextAttributes_2_1 && !contextAttributes_2_1.done && (_a = contextAttributes_2.return)) _a.call(contextAttributes_2);
            }
            finally { if (e_3) throw e_3.error; }
        }
    }
    return null;
};
export var getCtxCategoryFromString = function (ctxString) {
    var _a, _b;
    // this function is used to retrieve category when passed uid or id of a ctx attribute
    var regex = /^(?:.*?\.){2}(.*)$/gm;
    var m;
    var n;
    while ((m = regex.exec(ctxString)) !== null) {
        // This is necessary to avoid infinite loops with zero-width matches
        if (m.index === regex.lastIndex) {
            regex.lastIndex++;
        }
        n = (_b = (_a = m[1]) === null || _a === void 0 ? void 0 : _a.split('.')) === null || _b === void 0 ? void 0 : _b[0];
    }
    return n;
};
export var firstToUpperCase = function (str) {
    if (str.length === 0)
        return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
};
export var getDateTimeHTMLStringFromEpoch = function (epoch) {
    var date = epoch ? new Date(epoch * 1000) : new Date();
    var msOffset = date.getTimezoneOffset() * 60 * 1000;
    var msLocal = date.getTime() - msOffset;
    var dateLocal = new Date(msLocal);
    var isoLikeLocal = dateLocal.toISOString();
    var htmlDateTimeString = isoLikeLocal
        .slice(0, isoLikeLocal.lastIndexOf('.'))
        .slice(0, isoLikeLocal.lastIndexOf(':'));
    return htmlDateTimeString;
};
//# sourceMappingURL=helpers.js.map